module.exports = __webpack_public_path__ + "static/img/dashboard-bg.40e997c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-bg.jpg
// module id = 63
// module chunks = 35